import { defineMessages } from 'react-intl-next';

export const ConditionFilterMessages = defineMessages({
	AddNewCondition: {
		id: `eoc.integration-automation.condition-filter.add-new-condition`,
		defaultMessage: `Add condition`,
		description: `The text will be displayed in button that adds new condition rows to filter`,
	},
	MatchAll: {
		id: `eoc.integration-automation.condition-filter.match-types.match-all`,
		defaultMessage: `All the alerts (no conditions in use)`,
		description: `The text will be displayed in dropdown stating rule's filter will match with all`,
	},
	MatchAnyConditionOption: {
		id: `eoc.integration-automation.condition-filter.match-types.match-any-condition-option`,
		defaultMessage: `Alerts matching at least one condition`,
		description: `The text will be displayed in dropdown stating rule's filter has to match one or more conditions`,
	},
	MatchAllConditionsOption: {
		id: `eoc.integration-automation.condition-filter.match-types.match-all-conditions-option`,
		defaultMessage: `Alerts matching all the conditions`,
		description: `The text will be displayed in dropdown stating rule's filter has to match with all conditions`,
	},
	MatchAnyCondition: {
		id: `eoc.integration-automation.condition-filter.match-types.match-any-condition`,
		defaultMessage: `Only alerts that match any condition`,
		description: `The text will be displayed in dropdown stating rule's filter has to match one or more conditions`,
	},
	MatchAllConditions: {
		id: `eoc.integration-automation.condition-filter.match-types.match-all-conditions`,
		defaultMessage: `Only alerts that match all the conditions`,
		description: `The text will be displayed in dropdown stating rule's filter has to match with all conditions`,
	},
	OperationRegex: {
		id: `eoc.integration-automation.condition-filter.operations.regex`,
		defaultMessage: `Matches (Regex)`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationRegex: {
		id: `eoc.integration-automation.condition-filter.not.operations.regex`,
		defaultMessage: `Does not Matches (Regex)`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationContains: {
		id: `eoc.integration-automation.condition-filter.operations.contains`,
		defaultMessage: `Contains`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationContains: {
		id: `eoc.integration-automation.condition-filter.not.operations.contains`,
		defaultMessage: `Does not Contains`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationContainsKey: {
		id: `eoc.integration-automation.condition-filter.operations.contains-key`,
		defaultMessage: `Contains Key`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationContainsKey: {
		id: `eoc.integration-automation.condition-filter.not.operations.contains-key`,
		defaultMessage: `Does not Contains Key`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationContainsValue: {
		id: `eoc.integration-automation.condition-filter.operations.contains-value`,
		defaultMessage: `Contains Value`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationContainsValue: {
		id: `eoc.integration-automation.condition-filter.not.operations.contains-value`,
		defaultMessage: `Does not Contains Value`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationStartsWith: {
		id: `eoc.integration-automation.condition-filter.operations.starts-with`,
		defaultMessage: `Starts With`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationStartsWith: {
		id: `eoc.integration-automation.condition-filter.not.operations.starts-with`,
		defaultMessage: `Does not Starts With`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationEndsWith: {
		id: `eoc.integration-automation.condition-filter.operations.ends-with`,
		defaultMessage: `Ends With`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationEndsWith: {
		id: `eoc.integration-automation.condition-filter.not.operations.ends-with`,
		defaultMessage: `Does not Ends With`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationEquals: {
		id: `eoc.integration-automation.condition-filter.operations.equals`,
		defaultMessage: `Equals`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationEquals: {
		id: `eoc.integration-automation.condition-filter.not.operations.equals`,
		defaultMessage: `Is not Equals`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationIsEmpty: {
		id: `eoc.integration-automation.condition-filter.operations.is-empty`,
		defaultMessage: `Is Empty`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationIsEmpty: {
		id: `eoc.integration-automation.condition-filter.not.operations.is-empty`,
		defaultMessage: `Is not Empty`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationEqualsIgnoreWhitespace: {
		id: `eoc.integration-automation.condition-filter.operations.equals-ignore-whitespace`,
		defaultMessage: `Equals Ignore Whitespace`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationEqualsIgnoreWhitespace: {
		id: `eoc.integration-automation.condition-filter.not.operations.equals-ignore-whitespace`,
		defaultMessage: `Does not Equals Ignore Whitespace`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationGreaterThan: {
		id: `eoc.integration-automation.condition-filter.operations.greater-than`,
		defaultMessage: `Greater Than`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationGreaterThan: {
		id: `eoc.integration-automation.condition-filter.not.operations.greater-than`,
		defaultMessage: `Is not Greater Than`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	OperationLessThan: {
		id: `eoc.integration-automation.condition-filter.operations.less-than`,
		defaultMessage: `Less Than`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	NotOperationLessThan: {
		id: `eoc.integration-automation.condition-filter.not.operations.less-than`,
		defaultMessage: `Is not Less Than`,
		description: `The text will be displayed in dropdown for operation select`,
	},
	FieldKeyValue: {
		id: `eoc.integration-automation.condition-filter.field.key-value`,
		defaultMessage: `Details (Key-Value Based)`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldMessage: {
		id: `eoc.integration-automation.condition-filter.field.message`,
		defaultMessage: `Message`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldResponders: {
		id: `eoc.integration-automation.condition-filter.field.responders`,
		defaultMessage: `Responders`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldAlias: {
		id: `eoc.integration-automation.condition-filter.field.alias`,
		defaultMessage: `Alias`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldEntity: {
		id: `eoc.integration-automation.condition-filter.field.entity`,
		defaultMessage: `Entity`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldSource: {
		id: `eoc.integration-automation.condition-filter.field.source`,
		defaultMessage: `Source`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldTags: {
		id: `eoc.integration-automation.condition-filter.field.tags`,
		defaultMessage: `Tags`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldActions: {
		id: `eoc.integration-automation.condition-filter.field.actions`,
		defaultMessage: `Actions`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldDescription: {
		id: `eoc.integration-automation.condition-filter.field.description`,
		defaultMessage: `Description`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldDetails: {
		id: `eoc.integration-automation.condition-filter.field.details`,
		defaultMessage: `Details`,
		description: `The text will be displayed in dropdown for field select`,
	},
	FieldPriority: {
		id: `eoc.integration-automation.condition-filter.field.priority`,
		defaultMessage: `Priority`,
		description: `The text will be displayed in dropdown for field select`,
	},
	BooleanNot: {
		id: `eoc.integration-automation.condition-filter.boolean.not`,
		defaultMessage: `Not`,
		description: `The text will be displayed in dropdown for boolean select`,
	},
	DeleteIconLabel: {
		id: `eoc.integration-automation.condition-filter.button.delete-condition`,
		defaultMessage: `Delete Condition`,
		description: `The text will be used for icon label delete condition button`,
	},
	KeyValuePlaceholder: {
		id: `eoc.integration-automation.condition-filter.field.key-value-placeholder`,
		defaultMessage: `Key`,
		description: `The text will be used as a placeholder for the custom key-value input field`,
	},
	ExpectedValuePlaceholder: {
		id: `eoc.integration-automation.condition-filter.field.expected-value-placeholder`,
		defaultMessage: `Value`,
		description: `The text will be used as a placeholder for the expected-value input field`,
	},
	PriorityCritical: {
		id: `eoc.integration-automation.condition-filter.priority.critical`,
		defaultMessage: `P1-Critical`,
		description: `The text for condition filter's proirity selection, indicates critical severity`,
	},
	PriorityHigh: {
		id: `eoc.integration-automation.condition-filter.priority.critical`,
		defaultMessage: `P2-High`,
		description: `The text for condition filter's proirity selection, indicates high severity`,
	},
	PriorityModerate: {
		id: `eoc.integration-automation.condition-filter.priority.critical`,
		defaultMessage: `P3-Moderate`,
		description: `The text for condition filter's proirity selection, indicates moderate severity`,
	},
	PriorityLow: {
		id: `eoc.integration-automation.condition-filter.priority.critical`,
		defaultMessage: `P4-Low`,
		description: `The text for condition filter's proirity selection, indicates low severity`,
	},
	PriorityInformational: {
		id: `eoc.integration-automation.condition-filter.priority.critical`,
		defaultMessage: `P5-Informational`,
		description: `The text for condition filter's proirity selection, indicates informational severity`,
	},
	AlertFieldAriaLabel: {
		id: `eoc.integration-automation.condition-filter.alert-field-aria-label`,
		defaultMessage: `Select alert field`,
		description: `The text will be used for aria-label in dropdown for alert field select`,
	},
	IsNotFieldAriaLabel: {
		id: `eoc.integration-automation.condition-filter.is-not-field-aria-label`,
		defaultMessage: `Select IS or NOT operator`,
		description: `The text will be used for aria-label in dropdown for boolean select`,
	},
	ValueFieldAriaLabel: {
		id: `eoc.integration-automation.condition-filter.value-field-aria-label`,
		defaultMessage: `Select value field operator`,
		description: `The text will be used for aria-label in dropdown for value operator select`,
	},
	EnterKeyFieldAriaLabel: {
		id: `eoc.integration-automation.condition-filter.field.key-value-label`,
		defaultMessage: `Enter key`,
		description: `The text will be used for aria-label in textfield for key-value field`,
	},
	EnterValueFieldAriaLabel: {
		id: `eoc.integration-automation.condition-filter.enter-value-field-aria-label`,
		defaultMessage: `Enter value`,
		description: `The text will be used for aria-label in textfield for value field`,
	},
	PriorityFieldAriaLabel: {
		id: `eoc.integration-automation.condition-filter.priority-field-aria-label`,
		defaultMessage: `Select priority`,
		description: `The text will be used for aria-label in select for priority field`,
	},
	RemoveConditionButtonAriaLabel: {
		id: `eoc.integration-automation.condition-filter.remove-condition-button-aria-label`,
		defaultMessage: `Remove condition`,
		description: `The text will be used for aria-label in remove condition button`,
	},
	NewCustomDynamicPropertyInputHelper: {
		id: `eoc.integration-automation.condition-filter.new-custom-dynamic-property-input-helper`,
		defaultMessage: 'Syntax: {firstSyntax}, {secondSyntax} or {thirdSyntax}',
		description: 'Helper message for new property input',
	},
	NewCustomDynamicPropertyInputError: {
		id: `eoc.integration-automation.condition-filter.new-custom-dynamic-property-input-error`,
		defaultMessage: 'The correct syntax is {firstSyntax} or {secondSyntax} or {thirdSyntax}',
		description: 'Error message for new property input',
	},
	AlertFiltersHelperDescription: {
		id: `eoc.integration-automation.condition-filter.alert-filters-helper-description`,
		defaultMessage: `
			Choose from available alert properties or create a custom one with <b>{firstSyntax}</b>, <b>{secondSyntax}</b> or <b>{thirdSyntax}</b>.
		`,
		description: 'Helper text to select a property or create custom one',
	},
	AlertPropertyFieldLabel: {
		id: `eoc.integration-automation.condition-filter.alert-property-field-label`,
		defaultMessage: `Alert property`,
		description: 'Field label for alert properties',
	},
	ConditionFieldLabel: {
		id: `eoc.integration-automation.condition-filter.condition-field-label`,
		defaultMessage: `Condition`,
		description: 'Field label for conditions',
	},
	ValueFieldLabel: {
		id: `eoc.integration-automation.condition-filter.value-field-label`,
		defaultMessage: `Value`,
		description: 'Field label for values',
	},
	KeyFieldLabel: {
		id: `eoc.integration-automation.condition-filter.key-field-label`,
		defaultMessage: `Key`,
		description: 'Field label for keys',
	},
});
